import React from 'react'
import FormField, { FormFieldProps } from './FormField'
import { NumericInput, Typography, useColorMode } from '@airbus/components-react/components'
import FormControl from './FormControl'
import { FormControlProps } from '@airbus/components-react/components/Form'
import { NumericInputProps } from '@airbus/components-react/components/NumericInput'

type CustomNumericInputProps = NumericInputProps & FormControlProps

export const CustomNumericInput = ({
  label,
  error,
  readOnly = false,
  value,
  onChange,
  style,
  labelAdornment,
  required = false,
  ...rest
}: CustomNumericInputProps) => {
  const theme = useColorMode()

  return (
    <FormControl
      label={label}
      error={error}
      readOnly={readOnly}
      labelAdornment={labelAdornment}
      required={required}
      style={style}
    >
      {readOnly ? (
        <Typography
          style={{
            fontWeight: 'bold',
            textAlign: 'right',
            lineHeight: theme.size.spacing[40],
            overflowX: 'auto',
          }}
        >
          {value ?? '-'}
        </Typography>
      ) : (
        <NumericInput value={value} onChange={onChange} tabIndex={0} {...rest} />
      )}
    </FormControl>
  )
}

export const FormNumericInput = (props: FormFieldProps<CustomNumericInputProps>) => (
  <FormField {...props} Component={CustomNumericInput} />
)

export default FormNumericInput
